<template>
  <div>
    <PrintOnlyQuestionnaire :isAdmin="isAdmin" />
    <ScreenOnlyQuestionnaire :isAdmin="isAdmin" />
  </div>
</template>

<script>
import PrintOnlyQuestionnaire from './questionnaire/PrintOnlyQuestionnaire'
import ScreenOnlyQuestionnaire from './questionnaire/ScreenOnlyQuestionnaire'

export default {
  name: 'AppointmentQuestionnaire',

  components: {
    PrintOnlyQuestionnaire,
    ScreenOnlyQuestionnaire,
  },

  props: {
    isAdmin: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
}
</script>
